import StockPriceRegisterList from "../stock-price-register/StockPriceRegisterList";

export default function StockDetail() {
  return <StockPriceRegisterList />;
}
